<template>
<div>
  <v-dialog v-model="showDialog" max-width="40%" style="z-index:600" persistent no-click-animation>
    <v-card min-height="75%" min-width="95%">

      <v-toolbar color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>パスワード変更</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-divider></v-divider>

      <v-card-text>
        <v-container class="pa-2">
          <!-- ****************************************************************************************** --
              * 基本
            -- ****************************************************************************************** -->
          <v-row no-gutters>
            <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
              <dd-text-box
                v-model="ownpass.loginJininCdNm"
                label="人員コード/名称"
                ref="loginJininCdNm"
                :valueType="Ctrls.InputTypes.Free"
                :readonly="true"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12">
              <dd-section-title>新しいパスワード</dd-section-title>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
              <dd-password-box
                label="パスワード"
                v-model="ownpass.password"
                ref="password"
                :valueType="Ctrls.InputTypes.Alphanumeric"
                :append-icon="password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="password ? 'text' : 'password'"
                @click:append="password = !password"
                :required="true"
                />
            </v-col>
            <v-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" :cols="12" class="px-1">
              <dd-password-box
                label="再入力"
                v-model="ownpass.passwordNew"
                ref="passwordNew"
                :valueType="Ctrls.InputTypes.Alphanumeric"
                :append-icon="newpassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="newpassword ? 'text' : 'password'"
                @click:append="newpassword = !newpassword"
                :required="true"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider class="mt-1" />
      <v-card-actions>
        <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onCloseClick">閉じる</dd-custom-button >
        <v-spacer></v-spacer>
        <dd-custom-button class="mx-5" color="#2F75B5" :minWidth="100" @click="onSaveClick">保存</dd-custom-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
// DdComponents アルファベット順記述
import DdCustomButton from '@/components/DdCustomButton'
import DdSectionTitle from '@/components/DdSectionTitle'
import DdTextBox from '@/components/DdTextBox'
import DdPasswordBox from '@/components/DdPasswordBox'

// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
// import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
// import validators from '@/rahmen/validators'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'

// vue Definition
import { mapGetters } from 'vuex'

export default {
  name: 'DdPasswordEditDialog',
  mixins: [flowMixin],

  // 参照コンポーネント定義
  components: {
    DdCustomButton,
    DdSectionTitle,
    DdTextBox,
    DdPasswordBox
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
    * 読取モード
    */
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    invalidMessage: '',
    ownpass: {
    },
    // 表示制御
    password: false,
    newpassword: false,
    modeKengen: 0
  }),

  created () {
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)
  },

  watch: {
    showDialog: function (n) {
      if (n === true) {
        this.initBindVariables()
      }
    }
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      loginJininId: 'users/userId',
      loginJininNm: 'users/userName',
      loginJininCd: 'users/currentUserCode'
    })
  },
  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (![undefined, null].includes(kengen)) {
              if (kengen.kengenKbn === '10') {
                // 読取モード
                this.modeKengen = 0
              } else if (kengen.kengenKbn === '20') {
                // 削除不可モード
                this.modeKengen = 1
              } else {
                // フルアクセス
                this.modeKengen = 2
              }
              // thisId == 0 then 新規モード
              if (this.id === 0) {
                this.modeOfEdit = 0 // 新規モード
              } else if (this.modeKengen === 0) {
                this.modeOfEdit = 1 // 照会モード
              } else {
                this.modeOfEdit = 2 // 更新モード
              }
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForRegister(option)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const tmprec = {}
      tmprec.loginJininCdNm = this.loginJininCd + ' : ' + this.loginJininNm
      this.ownpass = Object.assign({}, tmprec)
      this.clearInvalidMessage(this.$refs)
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onCloseClick: function (e) {
      this.$emit('close', undefined)
    },
    // --------------------------------------------------------------------------------
    // 保存ボタン押下
    // --------------------------------------------------------------------------------
    onSaveClick: function (e) {
      this.clearInvalidMessage(this.$refs)
      if (this.ownpasswordRegisterValidate()) {
        this.onSaveAction()
      }
    },
    onSaveAction: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            this.Effects.loadComplete()
            if (data.isValid) {
              this.$emit('save', undefined)
              this.$emit('close', undefined)
              modals.showToastMessage('COMI0002', null, 500, null, 'info')
            } else {
              modals.showToastMessage('COME0022', null, 500, null, 'error')
            }
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isNoMessageModeMethod: function () {
          return true
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      const condition = {
        password: this.ownpass.password,
        passwordNew: this.ownpass.passwordNew,
        sysFlg: true
      }
      const f = this.HttpClient.post(`/api/v1/mstJinin/registerOwnPassword?id=${this.loginJininId}`, condition)
      return f
    },
    registerValidate: function () {
      return true
    },
    ownpasswordRegisterValidate: function () {
      const tmprec = Object.assign({}, this.ownpass)
      if (!tmprec.password) {
        this.$refs.password[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (!tmprec.passwordNew) {
        this.$refs.passwordNew[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      if (tmprec.password !== tmprec.passwordNew) {
        this.$refs.password[this.Ctrls.SET_INVALID_METHOD](message.get('COME0012'))
        this.$refs.passwordNew[this.Ctrls.SET_INVALID_METHOD](message.get('COME0012'))
        return false
      }
      return true
    }
  }
}
</script>
<style></style>
